// extracted by mini-css-extract-plugin
export default {"container":"_32fBq","banner":"_3oGRZ","value":"_1teLD"};